<template>
  <path pid="0" d="M15.5 2.29a11 11 0 104.19 19.44 1 1 0 00-1.22-1.58A9 9 0 1122 13v1a2 2 0 01-4 0v-1.22a5 5 0 10-1.26 3.54A4 4 0 0024 14v-1a11 11 0 00-8.5-10.71zM13 16a3 3 0 113-3 3 3 0 01-3 3z"/>
</template>
